import { apiV2, errorHandler } from "./index";
import {
  API_ERROR,
  FETCH_ALL_TOP_SEARCH,
  DELETE_TOP_SEARCH,
} from "../constants/ActionTypes";
import Swal from "sweetalert2";

export function fetchTopSearches() {
  return function (dispatch) {
    apiV2.get(`/top-searches`)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_TOP_SEARCH,
          payload: response.data.objects,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function deleteTopSearch(top_search_id) {
  return function (dispatch) {
    apiV2.delete(`/top-searches/${top_search_id}`)
      .then((response) => {
        dispatch({
          type: DELETE_TOP_SEARCH,
          payload: top_search_id,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function addOrEditTopSearch(top_search_data) {
  return function (dispatch) {
    const items = typeof top_search_data === 'string' ? JSON.parse(top_search_data) : top_search_data;
    const itemsWithSortOrder = items.map((item, index) => ({
      ...item,
      sort_order: index,
    }));
    const request = apiV2.post('/top-searches', { data: itemsWithSortOrder });

    request
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Top Search Updated!",
          timer: 1000,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
